import type { IScope } from "angular";
import { finalize } from "rxjs/operators";

import { cloneDeep } from "lodash";

import type { IResponseWithLoading, ISite } from "App/Modules/Models";
import type { ISitesRepository } from "App/Modules/Repositories";
import type { IFormContainerResolve } from "App/Modules/Services";
import { extendWithLoadingAndFail } from "App/Modules/Services/ObservableExtensions";

export default class EditSiteNotesComponentController {
    public static $inject: string[] = ["$scope", "mmSitesRepository"];

    public originalNotes: string;

    public notes: string;

    public editResponse: IResponseWithLoading<string>;

    public resolve: IFormContainerResolve<string, ISite>;

    constructor(private readonly $scope: IScope, private readonly sitesRepository: ISitesRepository) {}

    public $onInit() {
        this.originalNotes = this.resolve.formData;
        this.notes = cloneDeep(this.originalNotes);
    }

    public cancel() {
        if (this.resolve.options.onCancel) {
            this.resolve.options.onCancel();
        }
    }

    public editNotes() {
        extendWithLoadingAndFail(this.sitesRepository.putSiteNotes(this.resolve.bindings.id, this.notes))
            .pipe(finalize(() => this.$scope.$applyAsync()))
            .subscribe(
                (editResponse: IResponseWithLoading<string>) => {
                    this.editResponse = editResponse;
                    if (!editResponse.isLoading && editResponse.data) {
                        this.resolve.options.onOk(editResponse.data);
                    }
                },
                (errorResponse) => {
                    this.editResponse = errorResponse;
                },
            );
    }
}
